import { METAL_ROOF_CDN_PATH } from '../../metal-roof-constants';

export const METAL_ROOF_INFO_PRODUCTS_LIST = [
  {
    alt: 'Изображение Тепло-шумоизоляции',
    src: `${METAL_ROOF_CDN_PATH}/info/hea-sound-insulation.jpg/hea-sound-insulation.jpg`,
    title: 'Тепло-шумоизоляция',
  },
  {
    alt: 'Изображение Пароизоляции',
    src: `${METAL_ROOF_CDN_PATH}/info/vapor-barrier.jpg/vapor-barrier.jpg`,
    title: 'Пароизоляция',
  },
  {
    alt: 'Изображение Водосточной системы',
    src: `${METAL_ROOF_CDN_PATH}/info/drainage-system.jpg/drainage-system.jpg`,
    title: 'Водосточная система',
  },
  {
    alt: 'Изображение Кровельной вентиляция',
    src: `${METAL_ROOF_CDN_PATH}/info/roof-ventilation.jpg/roof-ventilation.jpg`,
    title: 'Кровельная вентиляция',
  },
  {
    alt: 'Изображение Мансардного окна',
    src: `${METAL_ROOF_CDN_PATH}/info/dormer-windows.jpg/dormer-windows.jpg`,
    title: 'Мансардные окна',
  },
  {
    alt: 'Изображение Снегозадержателей',
    src: `${METAL_ROOF_CDN_PATH}/info/snow-guards.jpg/snow-guards.jpg`,
    title: 'Снегозадержатели',
  },
];
